import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const SkipReviewModalWrapper = styled.div`
  padding: 24px;
`
export const SkipReviewModalHeader = styled.div`
  text-align: center;
  color: ${colors.mainText};
  font-size: 20px;
  font-weight: normal;
  margin-bottom: 24px;
`
export const SkipReviewModalText = styled.div`
  text-align: left;
  margin-bottom: 24px;
`
export const SkipReviewModalNote = styled.div`
  text-align: left;
`
export const GreenText = styled.span`
  color: ${colors.green};
`

export const ModalButtons = styled.div`
  margin: 24px auto 0;
  width: 276px;
  display: flex;
  justify-content: space-between;
`
